import axios from 'axios';
import FormField from '../formField/formField';
import Notice from '../notice/notice';
import { isEmail } from '../../utils/helpers';

export default class ContactForm {
    constructor(el) {
        this.el = el;
        this.submitForm = this.el.querySelector('.form');
        this.submitButton = this.el.querySelector('.button');
        this.fields = this.getFields();
        this.notice = new Notice();
        this.extraData = false;

        this.bindEvents();
    }

    bindEvents() {
        if (!this.submitForm) {
            this.el.addEventListener('submit', (event) => this.submitHandler(event));
        } else {
            this.submitForm.addEventListener('submit', (event) => this.submitHandler(event));
        }
    }

    setExtraData(extraData) {
        this.extraData = extraData;
    }

    getFields() {
        const fieldsEl = this.el.querySelectorAll('.formField');
        const fields = {};

        for (let i = 0; i < fieldsEl.length; i++) {
            let field = fieldsEl[i];
            let input = field.querySelector('input, textarea, .select');
            fields[input.name] = new FormField(field, input);
        }

        return fields;
    }

    submitHandler(event) {
        event.preventDefault();

        this.validate() ? this.submit() : this.showErrorMessage('client');
    }

    getFormData() {
        const data = [];

        for (var key in this.fields) {
            data.push(this.fields[key].getData());
        }

        return data;
    }

    validate() {
        return this.validName() && this.validContactInfo();
    }

    validName() {
        if (!this.fields['contact_form_name']) {
            return true;
        }

        const name = this.fields['contact_form_name'].getValue();
        return name.length > 1;
    }

    validContactInfo() {
        const phone = this.fields['contact_form_phone'].getValue();
        const email = this.fields['contact_form_email'].getValue();

        return phone.length > 4 && isEmail(email);
    }

    showSuccessMessage() {
        const text = window.formMessages.success_contact;
        this.notice.initNotice(text, 'success');
    }

    showErrorMessage(type) {
        let text = '';

        if (type === 'client') {
            text = window.formMessages.client_error;
        } else {
            text = window.formMessages.server_error;
        }

        this.notice.initNotice(text, 'error');
    }

    resetForm() {
        for (var key in this.fields) {
            this.fields[key].reset();
        }
    }

    submit() {
        const data = this.getFormData();
        const self = this;

        data.push({value: this.el.querySelector('input[name=lang]').value, name: 'lang', file: false});

        if (this.extraData) {
            data.push(this.extraData);
        }

        window.grecaptcha.ready(function() {
            window.grecaptcha.execute('6LdxRtAUAAAAAEL3rsSAdToJOlDEnKLttfhWSrvB', {action: 'submit_contactform'}).then(function(token) {
                axios
                    .post('/contact-form', {
                        data: data,
                        token: token,
                        action: 'submit_contactform'
                    })
                    .then(function(response) {
                        if (response.data) {
                            self.resetForm();
                            self.showSuccessMessage();
                            window.dataLayer.push({
                                event: 'formSubmitted',
                                formName: 'Form i sidfot'
                            });
                        } else {
                            self.showErrorMessage('server');
                        }
                    })
                    .catch(function(error) {
                        console.log(error);
                        self.showErrorMessage('server');
                    });
            });
        });
    }
}



// WEBPACK FOOTER //
// ./src/components/contactForm/contactForm.js